var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.pageTitle))]),_c('div',{staticClass:"content-body"},[_c('div',{staticClass:"block"},[_c('part-search-widget',{attrs:{"component-type":_vm.componentType}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }